import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Grid3X3, Heart, Info, Search, ChefHat } from 'lucide-react';

function Navbar({ onSearchToggle }) {
    const location = useLocation();

    const isActive = (path) => {
        return location.pathname === path;
    };

    return (
        <nav className="navbar">
            <div className="navbar-content">
                <div className="navbar-brand">
                    <Link to="/" className="brand-link">
                        <ChefHat size={24} />
                        <span className="brand-text">Cooksy</span>
                    </Link>
                </div>

                <div className="navbar-links">
                    <Link
                        to="/"
                        className={`navbar-link ${isActive('/') ? 'active' : ''}`}
                    >
                        <Home size={18} />
                        Home
                    </Link>
                    <Link
                        to="/categories"
                        className={`navbar-link ${isActive('/categories') ? 'active' : ''}`}
                    >
                        <Grid3X3 size={18} />
                        Categories
                    </Link>
                    <Link
                        to="/favorites"
                        className={`navbar-link ${isActive('/favorites') ? 'active' : ''}`}
                    >
                        <Heart size={18} />
                        Favorites
                    </Link>
                    <Link
                        to="/about"
                        className={`navbar-link ${isActive('/about') ? 'active' : ''}`}
                    >
                        <Info size={18} />
                        About
                    </Link>
                </div>

                <button
                    className="search-toggle"
                    onClick={onSearchToggle}
                    aria-label="Search recipes"
                >
                    <Search size={20} />
                </button>
            </div>
        </nav>
    );
}

export default Navbar;